import React from 'react'
import { REACTION_MAP, REACTION_ICONS } from '../../constants/reactions'

/**
 * ReactionIcon — renders a visual icon for a reaction type.
 *
 * States: idle (gray/dim), hover (color preview), active (filled color, scaled)
 * V1 uses styled emoji. Can upgrade to custom SVG later.
 */
function ReactionIcon({ type, state = 'idle', size = 24 }) {
  const reaction = REACTION_MAP[type]
  if (!reaction) return null

  const icon = REACTION_ICONS[type] || '?'

  const style = {
    fontSize: size,
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: state === 'idle' ? 0.55 : 1,
    filter: state === 'idle' ? 'grayscale(40%)' : 'none',
    transition: 'all 0.2s ease',
    transform: state === 'active' ? 'scale(1.15)' : 'scale(1)',
  }

  return (
    <span
      style={style}
      role="img"
      aria-label={reaction.label}
    >
      {icon}
    </span>
  )
}

export default ReactionIcon
